//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CityList from '@/components/common/CityList'
import FacultyMixin from '@/mixins/faculty.js'
import eventBus from '@/utils/eventBus'
import { mapState, mapGetters } from 'vuex'
import { LOCALE_CODE_RUSSIAN } from '@/const/locale'

export default {
  name: 'PrivacyHeader',
  components: { CityList },
  mixins: [FacultyMixin],
  props: {
    pageId: {
      type: String,
      required: true,
      default: 'agreement',
    },
  },
  data() {
    return {
      isMobileMenuActive: false,
      isTablet: null,
      ws_url: this.$getTextMainSetting('ws_url'),
      tg_url: this.$getTextMainSetting('tg_url'),
    }
  },
  computed: {
    ...mapGetters({
      currentLanguageCode: 'landings/currentLanguageCode',
    }),
    ...mapState(['i18n']),
    isCodingEnabled() {
      return this.isFacultyEnabled('coding') || false
    },
    isMathEnabled() {
      return (
        (this.isFacultyEnabled('math') &&
          this.$getTextMainSetting('branchLanguageCode') ===
            LOCALE_CODE_RUSSIAN) ||
        false
      )
    },
    isBootcampEnabled() {
      return false
    },
  },
  mounted() {
    this.windowSizeHandler()
    window.addEventListener('resize', this.windowSizeHandler, { passive: true })
  },
  methods: {
    getLogo() {
      if (this.$i18n.locale === 'ru') {
        return require('~/assets/img/pages/new-logo-ru.png')
      }
      return require('~/assets/img/pages/new-logo-en.png')
    },
    getWhiteLogo() {
      if (this.$i18n.locale === 'ru') {
        return require('~/assets/img/pages/logo-white-ru.svg')
      }
      return require('~/assets/img/pages/logo-white-en.svg')
    },
    openMobileMenu() {
      this.isMobileMenuActive = true
    },
    closeMobileMenu() {
      this.isMobileMenuActive = false
    },
    windowSizeHandler() {
      this.isTablet = window.innerWidth <= 960
    },
    onClickPhoneNumber() {
      eventBus.$emit('click-phone-number')
    },
    currentLanguage() {
      return this.currentLanguageCode.substr(0, 2)
    },
    changePageId(url) {
      this.$nuxt.$emit('change-page', url)
      this.closeMobileMenu()
    },
  },
}
